import React, { useEffect, useRef } from "react"
import cn from "class-names"
import css from "@css/modules/HottestDeals.module.scss"
import { Spin } from "antd"

export function LoadMoreDeals({ onLoadMore, hasMore }: { onLoadMore: () => void; hasMore: boolean }) {
    const ref = useRef<HTMLDivElement>(null)
    const intRef = useRef(() => {})
    intRef.current = hasMore ? onLoadMore : () => {}
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                intRef.current()
            }
        })
        if (ref.current) {
            observer.observe(ref.current)
        }
        return () => {
            if (ref.current) {
                observer.unobserve(ref.current)
            }
        }
    }, [])
    return (
        <div className={cn(css.loadMore, { [css.disabled]: !hasMore })} onClick={onLoadMore} ref={ref}>
            <Spin size="large" className={css.spinMore} />
        </div>
    )
}
